import { fromParallel } from "../../parallel/static/fromParallel.js";
export const asParallel = (source) => {
    const generator = async () => {
        const array = [];
        for (const value of source) {
            array.push(value);
        }
        return array;
    };
    return fromParallel(0, generator);
};
